<template>
  <a-table
    class="table datatable thead-light dq-report-table"
    :columns="columns"
    :data-source="dataSource"
    :loading="loading"
    :pagination="pagination"
    @change="onChange"
    row-key="key"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Employee'">
        <div class="d-flex align-items-center">
          <div class="ms-0">
            <p class="text-dark mb-0">{{ record.employee_name }}</p>
            <span class="fs-12">
              {{ record.employee_id }}
              <span v-if="record.designation"> • {{ record.designation }}</span>
              <span v-if="record.department"> • {{ record.department }}</span>
            </span>
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'DatePaid'">
        {{ record.date_paid_label || record.date_paid }}
      </template>

      <template v-else-if="moneyColumns.includes(column.key)">
        {{ currency }}
        {{
          Number(record[column.dataIndex] || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
        }}
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  currency: { type: String, default: "KES" },
  total: { type: Number, default: 0 },
  pageSize: { type: Number, default: 25 },
  current: { type: Number, default: 1 },
});
const emit = defineEmits(["change"]);

const columns = [
  { title: "Date Paid", dataIndex: "date_paid_label", key: "DatePaid" },
  { title: "Employee", dataIndex: "employee_name", key: "Employee" },
  { title: "Loan Type", dataIndex: "loan_type", key: "LoanType" },
  { title: "Amount Paid", dataIndex: "amount_paid", key: "AmountPaid" },
  { title: "Balance Remaining", dataIndex: "balance_remaining", key: "BalanceRemaining" },
];

const moneyColumns = ["AmountPaid", "BalanceRemaining"];

const dataSource = computed(() =>
  (props.rows || []).map((r, idx) => ({
    key: r.id || idx,
    date_paid: r.date_paid,
    date_paid_label: r.date_paid_label,
    period_label: r.period_label,
    employee_id: r.employee_id,
    employee_name: r.employee_name,
    department: r.department,
    designation: r.designation,
    loan_type: r.loan_type,
    amount_paid: r.amount_paid,
    balance_remaining: r.balance_remaining,
  }))
);

const pagination = computed(() => ({
  total: props.total,
  pageSize: props.pageSize,
  current: props.current,
  showTotal: (t) => `Total ${t} items`,
}));

function onChange(pagination, filters, sorter) {
  emit("change", pagination, filters, sorter);
}
</script>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 860px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
